import React from 'react';
import PropTypes from 'prop-types';

import TextSkeleton from '../LoadingSkeletons/TextLoadingSkeleton';

class AsyncComponent extends React.Component {
  static propTypes = {
    importer: PropTypes.func.isRequired,
    loadingSkeleton: PropTypes.element,
    preHook: PropTypes.func,
    postHook: PropTypes.func,
  };

  static defaultProps = {
    loadingSkeleton: <TextSkeleton />,
    preHook: () => {},
    postHook: () => {},
  };

  state = {
    Component: null,
  };

  async componentDidMount() {
    this.props.preHook();
    const { default: Component } = await this.props.importer();
    this.setState({ Component }, () => this.props.postHook());
  }

  render() {
    const Component = this.state.Component;
    if (!Component) return this.props.loadingSkeleton;
    return <Component {...this.props} />;
  }
}

export default AsyncComponent;
